export default __webpack_public_path__ + "static/media/red.8e5a852f.svg";